import { middlewares as loginMiddlewares } from './login';
import { middlewares as registerMiddlewares } from './register';

export const middlewares = [...loginMiddlewares, ...registerMiddlewares];
